export default {
  name: "PortfolioSuperSetChart",

  props: {
    content_class: {
      type: String,
      required: true,
    },
    chart_id: {
      type: String,
      default: "dashboard-main",
    },
    iframe_loading: {
      type: Boolean,
      default: false,
    },
    show_iframe: {
      type: Boolean,
      default: true,
    },
  },
};
